module.exports = __webpack_public_path__ + "img/labs1_1.9e5ca34d.svg";